import api from '../../utils/apiFetch';

const path = 'payouts';

export default {
  getOrgPayouts: (id) => api.get(`${path}?orgId=${id}`),
  createPayout: (payload) => api.post(`${path}`, payload),
};
